<template>
    <div>
        <el-dialog title="支付"
                   :visible.sync="isShow"
                   width="60%"
                   center>
            <div class="payCurrent"
                 v-if="Object.keys(paydb).length">
                <div class="user">
                    
                    <img v-if="paydb.avatar" :src="paydb.avatar" alt="头像" />
                    <img v-else src="@/assets/default_avatar.png" alt="头像" />
                    
                    <div>
                        <div class="name">{{ paydb.nickName }}(缩水师)</div>
                        <div class="tips">请用户注意账户安全，谨防上当受骗</div>
                    </div>
                </div>
                <h3 style="margin-top:50px">{{paydb.title}}</h3>
                <div class="content">
                    <div>
                        <span>{{ paydb.nickName }}</span>
                        <span>{{ paydb.number }}期</span>
                        <span>{{ paydb.indexName }}</span>
                        <span>{{paydb?.strJson?.back_number}}中{{paydb?.strJson?.correct_num}}期</span>
                    </div>
                    <div class="suobi"
                         v-if="paydb.price">{{ paydb.price }}缩币</div>
                </div>
                <div class="xieyi">
                    <input ref="input_xy"
                           type="checkbox" />
                    <span>同意</span><span class="xy"
                          @click="xy_isShow = true">缩水师网支付协议</span>
                </div>
                <span slot="footer"
                      class="dialog-footer">
                    <div class="btn"
                         @click="confirmPay">立即支付</div>
                </span>
            </div>
        </el-dialog>

        <el-dialog title="缩水网支付协议"
                   :visible.sync="xy_isShow"
                   width="60%"
                   center>
            <div>
                <p> 1、 缩水网的某些服务是以收费方式提供的。一旦凭个人账户密码通过个人帐户查阅和下载收费服务，将视为是您本人查阅和下载收费服务，您应按有关的收费标准、付款方式支付相关服务费及其他费用。资费说明标明在 缩水网网站相应服务的相应页面上。</p>
                <p> 2 、付费标准：服务费之标准应按潜江市晖喆商务信息服务部或合作公司关于付费标准规定办理。</p>
                <p> 3、依本服务条款所取得的服务权利不可转让。</p>
                <p> 4、遵守国家的有关法律、法规和行政规章制度。相关法律、法规和制度包括但不限于下列链接所提供的内容：</p>
                <p> 5、潜江市晖喆商务信息服务部对其发行的或与合作公司共同发行的包括但不限于产品或服务的全部内容及缩水网网站上的材料拥有版权等知识产权，受法律保护。</p>
                <p> 6、未经潜江市晖喆商务信息服务部书面许可，任何单位及个人不得以任何方式或理由对上述产品、服务、信息、材料的任何部分进行使用、复制、修改、抄录、传播或与其它产品捆绑使用、销售。</p>
                <p> 7、每项服务的内容、收费标准、收费方式、服务费及服务条款应以最后发布的通知为准。</p>
                <p> 8、凡侵犯本企业版权等知识产权的，本企业必依法追究其法律责任。</p>
                <p> 9、本企业法律事务部受本公司指示，特此郑重法律声明！</p>
                <p> 10、 如用户违反国家法律法规或本服务条款，本企业和合作公司将有权停止向用户提供服务而不需承担任何责任，如导致缩水网或合作公司遭受任何损害或遭受任何来自第三方的纠纷、诉讼、索赔要求等，用户须向本企业或合作公司赔偿相应的损失，用户并需对其违反服务条款所产生的一切后果负全部法律责任。</p>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import { queryDownloadFilePriceByRecordId } from "@/api/home";
import { createOrder } from "@/api/common"
export default {
    // props: ["paydb"],
    data () {
        return {
            xy_isShow: false,
            isShow: false,
            // price: "",
            // successParams: {},
            paydb: {},
        };
    },
    mounted () { },
    methods: {
        init (item) {
            this.isShow = true;
            this.paydb = item
            console.log('this.paydb', JSON.parse(JSON.stringify(this.paydb)));
        },
        confirmPay () {
            if (!this.$refs.input_xy.checked) {
                return this.$message.error("请先勾选同意缩水师支付协议");
            }
            this.isShow = false;

			let productAuthor = this.paydb.shrinkId || this.paydb.createUser;
			let createUserId = this.paydb.userId;
            let payParams = {
                money: this.paydb.price,
                productAuthor,
                payType: 'balancepay',
                productId: this.paydb.productId,
                productModel: '0',
                quantity: '1',
                title: (this.paydb?.title || '')  + new Date().getTime(),
                productSpecsId: this.paydb.specsId,
                uuid: new Date().getTime(),
				createUserId,
            }

            console.log('payParams', payParams);
            console.log('this.paydb', JSON.parse(JSON.stringify(this.paydb)));

            this.$http.post('/stage-api/order/v2/createOrder', payParams).then(resdb => {
                console.log('res', resdb);
                if (resdb.code == 200 && resdb.data.orderNo) {

                    if (localStorage.getItem("payStatus") == "pay") {
                        let orderNo = resdb.data.orderNo,
                            price = this.paydb.price,
                            item = this.paydb,
                            real_bet_number = this.paydb.strJson.real_bet_number

                        this.downloadFile(orderNo, price, item, real_bet_number)
                    }
                    if (localStorage.getItem("payStatus") == "look") {

                        setTimeout(function () {
                            // let orderNo = resdb.data.orderNo,
                            // 	price = this.paydb.price,
                            // 	indexName = this.paydb.indexName;

                            // 免费和收费查看彩种额外指标
                            this.$http.get('/stage-api/pre/detail/additional/indicators', {
                                params: {
                                    coin: payParams.money,
                                    orderNo: resdb.data.orderNo,
                                    pageNum: 1,
                                    pageSize: 10,
                                }
                            }).then(res => {
                                console.log('免费和收费查看彩种额外指标 - res', res);
                                if (res.code == 200) {
                                    this.$nextTick(() => {
                                        res.indexName = this.paydb.indexName
                                        this.$parent.$refs.ssqTable.$refs.lookPre.init(res)
                                    })
                                }
                            })
                        }.bind(this), 2000)
                    }

                    // if(localStorage.getItem("payStatus") == "pay"){
                    // 	this.$emit('pay_downFile_progress', {
                    // 		orderNo: resdb.data.orderNo,
                    // 		coin: this.paydb.price
                    // 	})
                    // 	localStorage.removeItem("payStatus")
                    // }

                    // if(localStorage.getItem("payStatus") == "look"){
                    // 	// alert('可以查阅')

                    // 	// 免费和收费查看彩种额外指标
                    // 	this.$http.get('/stage-api/pre/detail/additional/indicators', {
                    // 		params: {
                    // 			coin: payParams.money,
                    // 			orderNo: resdb.data.orderNo,
                    // 			pageNum: 1,
                    // 			pageSize: 10,
                    // 		}
                    // 	}).then(res => {
                    // 		console.log('免费和收费查看彩种额外指标 - res', res);
                    // 		// this.$refs.lookPre.init(res)
                    // 		this.$emit('look_downFile',res )
                    // 	})


                    // 	localStorage.removeItem("payStatus")
                    // }



                } else {
                    this.$message.error(resdb.msg)
                }

            })

            return

            if (this.paydb.checkStatus) {






                // let res = this.successParams

                // // 创建订单
                // createOrder({
                //     money: res.data.price,
                //     productAuthor: res.shrinkId,	//商家id
                //     payType: 'balancepay',
                //     productId: res.recordDetailId,
                //     productModel: 0,
                //     quantity: 1,
                //     title: this.$parent.lottery.arr[this.$parent.lottery.active] + this.paydb.nickName + res.number,
                //     uuid: new Date().getTime(),
                //     productSpecsId: res.recordDetailId,
                // }).then(res => {
                //     // console.log('res', res);
                //     if (res.code == 200) {
                //         this.$message.success('购买成功')
                //     } else {
                //         this.$message.error(res.msg)
                //     }
                // })
            } else {
                this.$emit("confirmPay", this.successParams);
            }

        },
        // 下载文件
        downloadFile (orderNo, price, item, real_bet_number) {
            let lotteryType = ['双色球', '大乐透', '福彩3D', '体彩排三']
            let that = this

            this.$confirm('您确定下载该缩水单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get('/stage-api/pre/detail/zipDownload', {
                    params: { orderNo, coin: price },
                    headers: { 'Authorization': 'Bearer ' + this.vuex_token },
                    responseType: 'blob',
                    onDownloadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        that.$vuex('vuex_downFile_progress', percentCompleted >= 100 ? false : percentCompleted)
                    },
                }).then(downRes => {
                    if (downRes.code == 500) { return this.$message.error(res.msg) }
                    let fileName = `${lotteryType[item.lotteryType * 1]}-${item.number}期-${item.nickName}-${real_bet_number}.zip`
                    this.$utils.downloadFile(downRes, fileName, 'application/zip')
                })
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.payCurrent {
    .user {
        display: flex;
        align-items: center;
        margin: 10px 0;
        img {
            margin-right: 20px;
            width: 70px;
            height: 70px;
            border-radius: 50%;
            background-color: gray;
        }
        .name {
            font-weight: bold;
            font-size: 25px;
            margin-bottom: 10px;
        }
        .tips {
            color: red;
        }
    }
    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        > div {
            width: 100%;
            display: flex;
            justify-content: space-around;
            border: 1px solid #999999;
            border-radius: 10px;
            margin: 20px 0;
            font-weight: bold;
            span {
                padding: 10px 0;
            }
        }
        .suobi {
            width: auto;
            display: inline-block;
            padding: 10px 30px;
            color: #fff;
            letter-spacing: 5px;
            background-color: #f4bb0b;
            border: 0;
        }
    }
    .xieyi,
    .btn {
        width: 80%;
        margin: 30px auto 0;
        &.btn {
            margin-top: 10px;
            background-color: #65a9f6;
            color: #fff;
            text-align: center;
            font-size: 25px;
            padding: 10px 0;
            font-weight: bold;
            border-radius: 10px;
        }
        .xy {
            color: #65a9f6;
            cursor: pointer;
        }
    }
}
</style>